export const Contact = (props) => {
  
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Application Form</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form
                method="POST"
                action="/confirmation-page"
                name="contactform"
                className="contactForm"
              >
                <input type="hidden" name="form-name" value="contactForm" />
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="firstName"
                        name="firstname"
                        className="form-control"
                        placeholder="First Name"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="middleName"
                        name="middlename"
                        className="form-control"
                        placeholder="Middle Name"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="lastName"
                        name="lastname"
                        className="form-control"
                        placeholder="Last Name"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="address"
                        name="address"
                        className="form-control"
                        placeholder="Address"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="city"
                        name="city"
                        className="form-control"
                        placeholder="City"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="province"
                        name="province"
                        className="form-control"
                        placeholder="Province"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="postalcode"
                        name="postalcode"
                        className="form-control"
                        placeholder="Postal Code"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="license"
                        name="driverlicense"
                        className="form-control"
                        placeholder="Driver's License #"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="province"
                        name="province"
                        className="form-control"
                        placeholder="Province"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="class"
                        name="class"
                        className="form-control"
                        placeholder="Class"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="cellphone"
                        name="cellphone"
                        className="form-control"
                        placeholder="Cell Phone"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="date"
                        id="dob"
                        name="dob"
                        className="form-control"
                        placeholder="Date of Birth (D/M ONLY)"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        id="emergencyContact"
                        name="emergencycontact"
                        className="form-control"
                        placeholder="Emergency Contact Number"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="memberSince"
                        name="membersince"
                        className="form-control"
                        placeholder="Member Since (The date membership issued)"
                        required
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Other motocycle club membership(s) held"
                    required
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="consent-checkbox-wrapper">
                  <div className="checkFlex consent-checkbox-flex">
                    <input 
                      type="checkbox" 
                      name="acceptance" 
                      id="acceptance" 
                      required 
                      className="consent-checkbox-input"
                    />
                    <label 
                      htmlFor="acceptance" 
                      className="consent-checkbox-label"
                    >
                      I accept{" "}
                      <a 
                        href="/terms-and-conditions" 
                        // target="_blank" 
                        className="consent-link"
                      >
                        Terms & Conditions
                      </a>
                      {" "}and{" "}
                      <a 
                        href="/privacy-policy" 
                        // target="_blank"   
                        className="consent-link"
                      >
                        Privacy Policy
                      </a>
                    </label>
                  </div>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <h3>For any enquiries</h3>
            {/* <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div> */}
            {/* <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div> */}
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <div className="contact-item" style={{marginTop: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderLeft: '4px solid #608dfd', borderRadius: '4px'}}>
              <p style={{margin: 0, fontSize: '14px', color: '#555', lineHeight: '1.6'}}>
                <i className="fa fa-info-circle" style={{marginRight: '8px', color: '#608dfd'}}></i>
                <strong>NOTE:</strong> Yearly Membership fee is $100/person (Non-Refundable)
              </p>
            </div>
          </div>
          {/* <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : '/'}>
                      <i className='fa fa-youtube'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
